<div class="container" style="margin-top: 40vh; justify-content: center; display: flex;">
    <svg style="height: 32px; width: 32px;"> <use xlink:href="#dds__loading-sqrs"></use>
    </svg>&nbsp;&nbsp;&nbsp;
    <span style="margin-top: 1vh ;">{{loadingMessage}}</span>
</div>
